import clone from 'lodash/clone'

/**
 * Return a shallow copy of an object with all elements that pass the test
 * implemented by the provided function
 * @param {Object} obj - The object to be filtered
 * @param {function(any, string):boolean} callback - The function to test each element
 */
export const filterShallowObject = (obj, callback) => {
  let filterObj = Object.create({})

  Object.keys(obj).forEach(key => {
    const element = obj[key]
    const shouldKeep = callback(element, key)

    if (shouldKeep) { filterObj[key] = obj[key] }
  })

  return filterObj
}

/**
 * Return a shallow copy of an object with the results of a provided function
 * @param {object} obj - The object to be filtered
 * @param {function(any, string):void} callback - The function that produces the element
 */
export const mapShallowValues = (obj, callback) => {
  let cloneObj = clone(obj)

  Object.keys(cloneObj).forEach(key => {
    const element = obj[key]

    cloneObj[key] = callback(element, key)
  })

  return cloneObj
}

export default {
  filterShallowObject,
  mapShallowValues,
}